import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { logo } from '../../assets';
import NavSection from '../../components/NavSection';
import { SIDEBAR_WIDTH } from '../../utils/layoutUtils';
import sidebarConfig from './SidebarConfig';
import SidePanel from '../../components/Bootstrap/SidePanel';
import './AppSidebar.css';

export default function AppSidebar({ drawerWidth, handleDrawerToggle, mobileOpen }) {
  const drawerContent = (
    <div className="sidebar-shell">
      <div className="sidebar-shell__brand">
        <RouterLink to="/dashboard" className="sidebar-shell__brand-link text-decoration-none">
          <img
            src={logo}
            alt="XS Sites"
            className="app-logo sidebar-shell__logo"
            decoding="async"
          />
          <div className="sidebar-shell__brand-text">
            <span className="sidebar-shell__brand-name">XS Sites</span>
            <span className="sidebar-shell__brand-tag">Admin Panel</span>
          </div>
        </RouterLink>
      </div>
      <NavSection navConfig={sidebarConfig()} />
    </div>
  );

  return (
    <nav
      className="app-sidebar-nav d-none d-sm-block"
      style={{ width: drawerWidth }}
      aria-label="Admin navigation"
    >
      {/* Mobile drawer via SidePanel */}
      <div className="d-block d-sm-none">
        <SidePanel
          open={mobileOpen}
          onClose={handleDrawerToggle}
          anchor="left"
          width={SIDEBAR_WIDTH}
        >
          {drawerContent}
        </SidePanel>
      </div>

      {/* Permanent desktop drawer */}
      <div
        className="app-sidebar-desktop"
        style={{
          width: SIDEBAR_WIDTH,
          marginLeft: drawerWidth === 0 ? `-${SIDEBAR_WIDTH}px` : '0px',
        }}
      >
        {drawerContent}
      </div>
    </nav>
  );
}
